import { render, staticRenderFns } from "./waybills.vue?vue&type=template&id=35e37236&scoped=true&"
import script from "./waybills.vue?vue&type=script&lang=js&"
export * from "./waybills.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35e37236",
  null
  
)

export default component.exports